
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.75 10a.75.75 0 01.743.648l.007.102v6a1.75 1.75 0 01-1.607 1.744l-.143.006h-11a1.75 1.75 0 01-1.744-1.607L3 16.75v-6a.75.75 0 011.493-.102l.007.102v6a.25.25 0 00.193.243L4.75 17h11a.25.25 0 00.243-.193L16 16.75v-6a.75.75 0 01.75-.75zm-.402-8H4.15a1.25 1.25 0 00-1.22.978l-.913 4.11L2 7.25A2.25 2.25 0 004.25 9.5l.154-.005c.445-.03.855-.19 1.192-.442l.154-.127.014.013c.396.35.916.561 1.486.561l.154-.005c.445-.03.855-.19 1.192-.442l.154-.127.014.013c.396.35.916.561 1.486.561l.154-.005c.446-.03.855-.19 1.192-.442l.154-.127.014.013c.396.35.917.561 1.486.561l.154-.005c.446-.03.855-.19 1.192-.442l.154-.127.014.013A2.25 2.25 0 0018.5 7.25l-.018-.162-.913-4.108A1.25 1.25 0 0016.348 2zm-.2 1.499l.847 3.816L17 7.25a.75.75 0 01-1.493.102L15.5 7.25c0-.958-1.378-.998-1.492-.12L14 7.25a.75.75 0 01-1.493.102L12.5 7.25c0-.958-1.378-.998-1.492-.12L11 7.25a.75.75 0 01-1.493.102L9.5 7.25c0-.958-1.378-.998-1.492-.12L8 7.25a.75.75 0 01-1.493.102L6.5 7.25c0-.958-1.378-.998-1.492-.12L5 7.25a.75.75 0 01-.75.75l-.102-.007a.75.75 0 01-.641-.641l-.003-.038.846-3.815h11.798z"}}),_c('path',{attrs:{"d":"M12.25 13a.75.75 0 01.102 1.493l-.102.007h-8.5a.75.75 0 01-.102-1.493L3.75 13h8.5z"}}),_c('path',{attrs:{"d":"M12.25 10a.75.75 0 01.743.648l.007.102v7a.75.75 0 01-1.493.102l-.007-.102v-7a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    